import { ImageCheckType, ImageType } from "Explore/Config/ImageType";
import styles from "./HomeUnitCard.module.scss";
import { ImageCheck, LinkWrapper } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { Grid } from "@mui/material";
import { numberRegex } from "Explore/Utils/numberRegex";
import classNames from "classnames";

const HomeUnitCard = ({ data = {} }) => {
  const statisticData = [
    {
      icon: IconPack.publications,
      title: "publications",
      value: data.total_publication,
    },
    { icon: IconPack.citation, title: "citations", value: data.total_citation },
    { icon: IconPack.h_index, title: "h-index", value: data.total_h_index },
    {
      icon: IconPack.unit_faculty_members,
      title: "faculty members",
      value: data.total_faculties,
    },
    {
      icon: IconPack.seniority,
      title: "average academic age",
      value: data.average_seniority,
    },
  ].filter((e) => !!e.value);

  return (
    <LinkWrapper
      className={styles["home-unit-card--wrapper"]}
      link={`/explore/unit/${data.explore_slug || data.id}`}
      component={
        <div className={styles["home-unit-card"]}>
          <div className={styles["home-unit-card--background-cover"]}>
            <ImageCheck
              url={`https://media.academic.online/institutions_images/${data.institution_id}/${ImageType.LANDSCAPE}.png`}
              className={styles["home-unit-card--background-cover--image"]}
              alt="background-cover"
              type={ImageCheckType.INSTITUTION_LOGO}
            />
            {!!data.level && (
              <div
                className={styles["home-unit-card--background-cover--level"]}
              >
                <p>{data.level}</p>
              </div>
            )}
          </div>
          <div className={styles["home-unit-card--info"]}>
            <div className={styles["home-unit-card--info--text"]}>
              <p
                className={classNames(
                  styles["home-unit-card--info--text--title"],
                  { [styles["long-text"]]: data.name?.length > 30 }
                )}
              >
                {data.name}
              </p>
              <p className={styles["home-unit-card--info--text--subtitle"]}>
                {data.institution_name}
              </p>
            </div>
            <Grid
              container
              spacing="8px"
              className={styles["home-unit-card--info--statistics"]}
            >
              {statisticData.map(({ icon, title, value }, i) => (
                <Grid item xs={12} md={6} key={i}>
                  <div
                    className={styles["home-unit-card--info--statistics--item"]}
                  >
                    {icon}
                    <p>
                      <span>{numberRegex(value)}</span> {title}
                    </p>
                  </div>
                </Grid>
              ))}
            </Grid>
            <div className={styles["home-unit-card--info--keywords"]}>
              {(data.keywords || []).slice(0, 2).map((e, i) => (
                <div
                  className={styles["home-unit-card--info--keywords--item"]}
                  key={i}
                >
                  <p>{e.value}</p>
                </div>
              ))}
            </div>
          </div>
          <div className={styles["home-unit-card--avatar"]}>
            <ImageCheck
              url={`https://media.academic.online/institutions_images/${data.institution_id}/${ImageType.SEAL}.png`}
              className={styles["home-unit-card--avatar--image"]}
              alt={"avatar"}
              type={ImageCheckType.INSTITUTION_LOGO}
            />
          </div>
        </div>
      }
    />
  );
};

export default HomeUnitCard;
